import { getAngularBaseUrl, getBaseUrl } from '../baseUrlService'
import { Environment, getEnvironment } from '../environmentService'
import { EnvironmentAction } from './actions'

export interface EnvironmentState {
  environment: Environment,
  baseUrl: string,
  angularBaseUrl: string
}

const initialState: EnvironmentState = {
  angularBaseUrl: getAngularBaseUrl(),
  baseUrl: getBaseUrl(),
  environment: getEnvironment()
}

const reducer = (state: EnvironmentState = initialState, action: EnvironmentAction): EnvironmentState => state

export default reducer
